import { toJS } from "mobx";
import { stringify, parse } from "query-string";

import { Form } from "lib/form";

interface QueryForm {
  [key: string]: any;
}

const formatQueryForm = (form: Form, page?: number): QueryForm => {
  const queryForm: QueryForm = {};
  Object.keys(form.fields).forEach((key: keyof typeof form.fields) => {
    const value = toJS(form[key]);
    if (value) {
      queryForm[key] = Array.isArray(value)
        ? value.map((v) => objectToJson(v))
        : objectToJson(value);
    }
  });
  queryForm.page = page ? page.toString() : undefined;

  return queryForm;
};

export const formatQueryString = (form: Form, page?: number): string => {
  return stringify(formatQueryForm(form, page), { arrayFormat: "bracket" });
};

export const parseQueryString = (
  queryString: string,
  filter: Form,
): { form: { [key: string]: any }; page: number } => {
  const queryForm: QueryForm = parse(queryString, { arrayFormat: "bracket" });
  const convertedForm: { [key: string]: any } = {};
  Object.keys(queryForm)
    .filter((key: string) => filter.fields[key])
    .forEach((key) => {
      if (Array.isArray(queryForm[key])) {
        convertedForm[key] = queryForm[key].map((v: any) => jsonToObject(v));
      } else if (
        (typeof filter[key] === "number" ||
          filter[key] === undefined ||
          filter[key] === null) &&
        !isNaN(Number(queryForm[key]))
      ) {
        convertedForm[key] = parseInt(queryForm[key], 10);
      } else if (
        typeof filter[key] === "string" &&
        typeof queryForm[key] === "string"
      ) {
        convertedForm[key] = queryForm[key];
      } else {
        convertedForm[key] = jsonToObject(queryForm[key]);
      }
    });

  return {
    form: convertedForm,
    page: queryForm.page ? parseInt(queryForm.page, 10) : 1,
  };
};

const objectToJson = (obj: any) => {
  return typeof obj === "object" && obj !== null ? JSON.stringify(obj) : obj;
};

const jsonToObject = (json: string) => {
  try {
    return JSON.parse(json);
  } catch (error) {
    return json;
  }
};
